import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={13}
    height={15}
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      d="M6.5 14.8571L0 8.35714H3.71429V0L9.28571 0V8.35714H13L6.5 14.8571Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
